/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedNotificationsResponse } from '../models/PaginatedNotificationsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminNotificationsService {
    /**
     * Get Notifications
     * Newest-first org feed; live bulk-action counts projected per item.
     * @param limit
     * @param offset
     * @returns PaginatedNotificationsResponse Successful Response
     * @throws ApiError
     */
    public static getNotificationsApiAdminNotificationsGet(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<PaginatedNotificationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/notifications',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notifications
     * Newest-first org feed; live bulk-action counts projected per item.
     * @param limit
     * @param offset
     * @returns PaginatedNotificationsResponse Successful Response
     * @throws ApiError
     */
    public static getNotificationsAdminNotificationsGet(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<PaginatedNotificationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/notifications',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
